import HT from 'handsontable';

export function makeAfterUpdateData<R extends HT.RowObject>(onChange: (data: R[]) => void) {
  return function afterUpdateData(data: R[]): void {
    this.validateCells();
    onChange(data);
  };
}
